import { render, staticRenderFns } from "./UsedProductPricesList.vue?vue&type=template&id=4cb4e3de&"
import script from "./UsedProductPricesList.vue?vue&type=script&lang=js&"
export * from "./UsedProductPricesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports